import type { IconType } from 'react-icons'
import {
  LuArrowRight,
  LuArrowLeft,
  LuArrowDown,
  LuArrowUp,
  LuUser,
  LuUsers,
  LuWifi,
  LuWifiOff,
  LuBuilding2,
  LuWarehouse,
  LuHourglass,
  LuMapPin,
  LuMapPinned,
  LuRadar,
  LuSettings,
  LuClock,
  LuBellRing,
  LuHistory,
  LuDoorOpen,
  LuDoorClosed,
  LuTriangleAlert,
  LuSnowflake,
  LuThermometerSnowflake,
  LuThermometerSun,
  LuThermometer,
  LuFuel,
  LuTruck,
  LuPower,
  LuPowerOff,
  LuZap,
  LuZapOff,
  LuChartNoAxesCombined,
  LuChartBarIncreasing,
  LuChartBarBig,
  LuChartPie,
  LuChartNetwork,
  LuAxis3D,
  LuLayoutDashboard,
  LuGauge,
  LuCheck,
  LuBattery,
} from 'react-icons/lu'
import { PiEngineBold } from 'react-icons/pi'
export const dashboardIcons = {
  arrowRight: LuArrowRight,
  arrowLeft: LuArrowLeft,
  arrowDown: LuArrowDown,
  arrowUp: LuArrowUp,
  user: LuUser,
  users: LuUsers,
  wifi: LuWifi,
  wifiOff: LuWifiOff,
  building: LuBuilding2,
  warehouse: LuWarehouse,
  hourglass: LuHourglass,
  mapMarker: LuMapPin,
  map: LuMapPinned,
  radar: LuRadar,
  cog: LuSettings,
  clock: LuClock,
  alarmBell: LuBellRing,
  history: LuHistory,
  doorOpen: LuDoorOpen,
  doorClosed: LuDoorClosed,
  triangleAlert: LuTriangleAlert,
  snowflake: LuSnowflake,
  thermometerSnow: LuThermometerSnowflake,
  thermometerSun: LuThermometerSun,
  thermometer: LuThermometer,
  fuel: LuFuel,
  truck: LuTruck,
  powerOn: LuPower,
  powerOff: LuPowerOff,
  electricOn: LuZap,
  electricOff: LuZapOff,
  chartNoAxes: LuChartNoAxesCombined,
  chartBarIncreasing: LuChartBarIncreasing,
  chartBar: LuChartBarBig,
  chartPie: LuChartPie,
  chartNetwork: LuChartNetwork,
  chartAxis: LuAxis3D,
  dashboard: LuLayoutDashboard,
  odometer: LuGauge,
  checkmark: LuCheck,
  battery: LuBattery,
  engine: PiEngineBold,
} as const

export const dashboardIconColors = {
  primary: 'text-primary',
  accent: 'text-accent',
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
} as const

export type DashboardIconKey = keyof typeof dashboardIcons
export type DashboardIconColorKey = keyof typeof dashboardIconColors

export function DashboardIcon({ name, color }: { name: string; color?: string }) {
  const Icon = (dashboardIcons as Record<string, IconType>)[name] ?? LuLayoutDashboard
  const colorClass = color ? (dashboardIconColors as Record<string, string>)[color] : undefined
  return <Icon size={20} className={colorClass ? `dashboard-icon ${colorClass}` : undefined} />
}
